module.exports = __webpack_public_path__ + "static/media/URWDINCond-Demi.d7153852.ttf";